// @flow

import PropTypes  from 'prop-types';
import React      from 'react';
import Link       from 'react-router-dom/Link';
import BaseButton from 'reactstrap/lib/Button';
import withProps  from 'recompose/withProps';
import styled     from 'styled-components';


export type ButtonSize =
  | 'sm'
  | 'lg'

export type ButtonProps = {
  shouldPrint?: boolean,
  to?: $PropertyType<Link, 'to'>,
};

const Button = ({shouldPrint, to, ...props}: ButtonProps) => {

  let CustomizedButton = BaseButton;

  if (to) {
    CustomizedButton = withProps(
      ({className, color}) => ({to, className: `${className} btn${color ? ` btn-${color}` : ''}`}),
    )(Link);
  }

  CustomizedButton = styled(CustomizedButton)`
    ${props => props.theme.button}
  `;

  if (!shouldPrint) {

    // noinspection JSUnusedAssignment
    CustomizedButton = styled(CustomizedButton)`
      @media print {
        display: none;
      }
    `;

  }

  return <CustomizedButton {...props}/>;

};


Button.propTypes = {
  // Whether the button should be printed or not
  shouldPrint: PropTypes.bool,

  to: PropTypes.string,
};


Button.defaultProps = {
  shouldPrint: false,
};


export default Button;



// WEBPACK FOOTER //
// ./src/modules/reactstrap/components/Button.js